<p>
  rooms works!
</p>

<p-overlayPanel #hoverPanel id="hoverPanel" [dismissable]="false">
  Content
</p-overlayPanel>
<app-actionpanel></app-actionpanel>